import { useState } from 'react';
import type { ReactNode } from 'react';
import { ProgressContext } from './ProgressContext';

export function ProgressProvider({ children }: { children: ReactNode }) {
  const [override, setOverride] = useState<number | null>(null);
  return (
    <ProgressContext.Provider value={{ override, setOverride }}>
      {children}
    </ProgressContext.Provider>
  );
}
